// Angular
import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';

// RxJS
import { catchError } from 'rxjs/operators';

// Data Contracts
import { JudgeReviewSummary } from '@data-contracts';

// Local
import { JudgeReviewApiService } from '@app/services/api/judge-review/judge-review-api.service';
import { ErrorsStateService } from '@app/services/ui-state/errors-state/errors-state.service';
import { ROUTES } from '@routes';

/**
 * Resolver to pre-load judge review summaries before activating the judge-review-list route.
 * On error (e.g. 401/403), shows an error message and navigates to the home route.
 */
export const judgeReviewListResolver: ResolveFn<JudgeReviewSummary> = () => {
  /**
   * The judge review api service.
   */
  const judgeReviewApiService = inject(JudgeReviewApiService);

  /**
   * The errors state service.
   */
  const errorsStateService = inject(ErrorsStateService);

  /**
   * The angular router.
   */
  const router = inject(Router);

  return judgeReviewApiService.getJudgeReviewItemSummaries().pipe(
    catchError(err => {
      console.error(
        'An error occurred while fetching judge review data.',
        err,
      );
      errorsStateService.showError(
        'An error occurred while fetching judge review data.',
      );
      void router.navigate([ROUTES.HOME]);
      // Throw error to indicate resolver failed
      throw err;
    }),
  );
};
